import { useCallback, useMemo } from "react";
import useLocalStorage from "./useLocalStorage";

export const useNotificationLocalStorage = () => {
    const { localStorageValue, setLocalStorageStateValue } = useLocalStorage({
        key: "readNotifications",
        defaultValue: [],
    });

    const readNotifications = useMemo(
        () => new Set<string>(localStorageValue),
        [localStorageValue]
    );

    const isNotificationRead = useCallback(
        (notificationId: string): boolean => {
            return readNotifications.has(notificationId);
        },
        [readNotifications]
    );

    const markAsRead = useCallback(
        (notificationId: string) => {
            if (!readNotifications.has(notificationId)) {
                // Convert Set to array before storing in localStorage
                setLocalStorageStateValue([
                    ...Array.from(readNotifications),
                    notificationId,
                ]);
            }
        },
        [readNotifications, setLocalStorageStateValue]
    );

    return {
        isNotificationRead,
        markAsRead,
    };
};
